import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M12 14V4', key: '1t7zjg' }],
  [
    'path',
    {
      d: 'M7.674 10.774 2.58 13.09a1 1 0 000 1.822l8.6 3.91a2 2 0 001.65 0l8.58-3.9a1 1 0 00.59-.92 1 1 0 00-.59-.922l-5.078-2.308',
      key: '1cy4ex',
    },
  ],
  ['path', { d: 'm9 7 3-3 3 3', key: '8sjys4' }],
];

/**
 * @component @name LayerArrowUp
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTRWNCIgLz4KICA8cGF0aCBkPSJNNy42NzQgMTAuNzc0IDIuNTggMTMuMDlhMSAxIDAgMDAwIDEuODIybDguNiAzLjkxYTIgMiAwIDAwMS42NSAwbDguNTgtMy45YTEgMSAwIDAwLjU5LS45MiAxIDEgMCAwMC0uNTktLjkyMmwtNS4wNzgtMi4zMDgiIC8+CiAgPHBhdGggZD0ibTkgNyAzLTMgMyAzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/layer-arrow-up
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LayerArrowUp = createLucideIcon('layer-arrow-up', __iconNode);

export default LayerArrowUp;
